import React from 'react'
import Nav from './nav'
import Footer from './Footer'
import AdBanner from './AdBanner'
import NativeBanner from './NativeBanner'
export default function Privacypolicy() {
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f9fa',
      fontFamily: 'Arial, sans-serif'
    },
    policySection: {
      flex: 1,
      maxWidth: '800px',
      margin: '40px auto',
      padding: '40px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 2px 20px rgba(0,0,0,0.08)',
      lineHeight: '1.8',
      color: '#333'
    },
    heading: {
      textAlign: 'center',
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '30px',
      paddingBottom: '20px',
      borderBottom: '3px solid #007bff',
      position: 'relative'
    },
    headingUnderline: {
      position: 'absolute',
      bottom: '-3px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '50px',
      height: '3px',
      backgroundColor: '#007bff'
    },
    subHeading: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#007bff',
      marginTop: '30px',
      marginBottom: '15px',
      paddingBottom: '10px',
      borderBottom: '2px solid #e9ecef'
    },
    subHeadingSmall: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#007bff',
      marginTop: '25px',
      marginBottom: '10px'
    },
    paragraph: {
      fontSize: '16px',
      marginBottom: '15px',
      color: '#555',
      lineHeight: '1.8'
    },
    lastUpdated: {
      backgroundColor: '#f0f7ff',
      padding: '15px 20px',
      borderRadius: '8px',
      marginBottom: '20px',
      borderLeft: '5px solid #007bff'
    },
    lastUpdatedText: {
      margin: 0,
      color: '#333',
      fontSize: '16px'
    },
    list: {
      listStyle: 'none',
      padding: '0',
      margin: '15px 0'
    },
    listItem: {
      padding: '10px 15px',
      marginBottom: '8px',
      backgroundColor: '#f8f9fa',
      borderRadius: '6px',
      borderLeft: '4px solid #007bff',
      fontSize: '15px',
      color: '#555',
      transition: 'all 0.3s ease'
    },
    listItemHover: {
      backgroundColor: '#e9ecef',
      transform: 'translateX(5px)'
    },
    infoBox: {
      backgroundColor: '#f8f9fa',
      padding: '20px 25px',
      borderRadius: '8px',
      margin: '20px 0',
      borderLeft: '5px solid #28a745'
    },
    infoBoxText: {
      margin: 0,
      color: '#555',
      fontSize: '16px'
    },
    highlight: {
      color: '#007bff',
      fontWeight: '600'
    },
    // Mobile Styles
    '@media (max-width: 768px)': {
      policySection: {
        margin: '20px 15px',
        padding: '25px 20px'
      },
      heading: {
        fontSize: '24px'
      },
      subHeading: {
        fontSize: '19px'
      },
      subHeadingSmall: {
        fontSize: '16px'
      },
      paragraph: {
        fontSize: '14px'
      },
      listItem: {
        fontSize: '14px',
        padding: '8px 12px'
      },
      lastUpdated: {
        padding: '12px 15px'
      },
      infoBox: {
        padding: '15px'
      },
      infoBoxText: {
        fontSize: '14px'
      }
    },
    '@media (max-width: 480px)': {
      policySection: {
        margin: '15px 10px',
        padding: '20px 15px'
      },
      heading: {
        fontSize: '20px'
      },
      subHeading: {
        fontSize: '17px'
      },
      lastUpdatedText: {
        fontSize: '14px'
      }
    }
  }

  return (
    <div style={styles.container}>
      <Nav />
              <AdBanner />
      <div style={styles.policySection}>
        <h1 style={styles.heading}>
          Privacy Policy
          <span style={styles.headingUnderline}></span>
        </h1>
      
                <NativeBanner />
        <div style={styles.lastUpdated}>
          <p style={styles.lastUpdatedText}>
            📅 <strong>Last Updated:</strong> July 13, 2026
          </p>
        </div>

        <p style={styles.paragraph}>
          Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information.
        </p>

        <h2 style={styles.subHeading}>
          Information We Collect
        </h2>
        
        <ul style={styles.list}>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            📝 Name (if voluntarily provided)
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            📧 Email address (if you contact us)
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            💻 Device and browser information
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            📊 Download statistics and website usage data
          </li>
        </ul>

        <h2 style={styles.subHeading}>
          How We Use Your Information
        </h2>
        
        <div style={styles.infoBox}>
          <p style={styles.infoBoxText}>
            We use your information to:
          </p>
        </div>
        
        <ul style={styles.list}>
          <li 
            style={{...styles.listItem, borderLeftColor: '#28a745'}}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            ✅ Improve our website and application.
          </li>
          <li 
            style={{...styles.listItem, borderLeftColor: '#28a745'}}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            ✅ Respond to your inquiries.
          </li>
          <li 
            style={{...styles.listItem, borderLeftColor: '#28a745'}}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            ✅ Provide customer support.
          </li>
          <li 
            style={{...styles.listItem, borderLeftColor: '#28a745'}}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            ✅ Enhance user experience.
          </li>
        </ul>

        <h2 style={styles.subHeading}>
          Data Protection
        </h2>
        
        <p style={styles.paragraph}>
          We take appropriate security measures to protect your personal information from unauthorized access, alteration, or disclosure. 🛡️
        </p>

        <h2 style={styles.subHeading}>
          Third-Party Services
        </h2>
        
        <p style={styles.paragraph}>
          Our website may use trusted third-party services such as analytics tools or hosting providers to improve performance. 🔗
        </p>

        <h2 style={styles.subHeading}>
          Cookies
        </h2>
        
        <p style={styles.paragraph}>
          We may use cookies to improve your browsing experience. You can disable cookies through your browser settings if you prefer. 🍪
        </p>

        <h2 style={styles.subHeading}>
          Changes to This Policy
        </h2>
        
        <p style={styles.paragraph}>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page. 📝
        </p>

        <h2 style={styles.subHeading}>
          Contact Us
        </h2>
        
        <div style={{...styles.infoBox, borderLeftColor: '#007bff'}}>
          <p style={styles.infoBoxText}>
            If you have any questions regarding this Privacy Policy, please <a 
              href="/contact" 
              style={{
                color: '#007bff',
                textDecoration: 'none',
                fontWeight: '600'
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline'
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none'
              }}
            >
              contact us
            </a> through the Contact page. 📧
          </p>
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: '30px',
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          fontSize: '14px',
          color: '#888'
        }}>
          <p style={{margin: 0}}>
            🔒 Your privacy matters to us. Thank you for trusting <strong style={styles.highlight}>APKNU.com</strong>.
          </p>
        </div>
      </div>
              <AdBanner />
      <Footer />
    </div>
  )
}